(function ($, win) {
    "use strict";

    var elaticHovers = [];

    var ElasticHover = function (element, data) {
        element.__ptElasticHover = this;
        elaticHovers.push(this);

        this._element = element;

        createjs.Ticker.timingMode = createjs.Ticker.RAF;

        this._direct = data.direct || 'xy';

        this._tweenSpeed = data.tweenSpeed === undefined ? 500 : data.tweenSpeed;
        this._backSpeed = data.backSpeed === undefined ? 800 : data.backSpeed;

        this._tweenEase = data.tweenEase || createjs.Ease.quintOut;
        this._backEase = data.backEase || createjs.Ease.quintOut;

        this._scale = data.scale === undefined ? 1 : data.scale;
        this._scaleSpeed = data.scaleSpeed === undefined ? 500 : data.scaleSpeed;

        this.$element = $(element);

        if (data.target) {
            this.$target = this.$element.find(data.target);
        }
        else {
            this.$target = this.$element;
        }

        this._disposed = false;
        this._isMoving = false;

        this._allowCalls = ['dispose'];

        this._offset = data.offset || 10;
        this._rect = { x: 0, y: 0, w: 0, h: 0 };

        this._aniValueX = 0;
        this._aniValueY = 0;
        this._scaleObj = { scale: 1 };

        this.$element.hover(this._onOver.bind(this), this._onOut.bind(this));

        this._onMovingHandler = this._onMoving.bind(this);
    }

    var p = ElasticHover.prototype;

    p._onOver = function () {
        setTimeout(function () {

            $(win).on('mousemove', this._onMovingHandler);
            var w = this.$element.width(), h = this.$element.outerHeight();
            var jOffset = this.$element.offset();
            var offsetX = jOffset.left, offsetY = jOffset.top;
            this._rect.x = offsetX - this._offset;
            this._rect.y = offsetY - this._offset;
            this._rect.w = w + this._offset * 2;
            this._rect.h = h + this._offset * 2;

            this._zoom(this._scale);

            this._isMoving = true;

        }.bind(this), 100);

        var i, eh, len = elaticHovers.length;
        for (i = 0; i < len; i++) {
            eh = elaticHovers[i];
            if (eh && eh !== this) {
                eh.stop();
            }
        }
    }

    p._onOut = function () {
        //
    }

    p._onMoving = function (evt) {
        var mx = evt.pageX, my = evt.pageY;
        var percentX = (mx - this._rect.x) / this._rect.w;
        var percentY = (my - this._rect.y) / this._rect.h;

        var x = percentX * 2 * this._offset - this._offset;
        var y = percentY * 2 * this._offset - this._offset;

        if (x < -this._offset || x > this._offset || y < -this._offset || y > this._offset) {
            this.stop();
        }
        else {
            if (this._direct === 'x') {
                y = 0;
            }
            else if (this._direct === 'y') {
                x = 0;
            }

            this._render(x, y, this._tweenSpeed, this._tweenEase);
        }
    }

    p._zoom = function (value) {
        if (this._scale !== 1) {
            createjs.Tween.get(
                this._scaleObj,
                {
                    override: true,
                    onChange: this._onAniUpdate.bind(this)
                }
            ).to(
                {
                    scale: value,
                },
                this._scaleSpeed,
                createjs.Ease.cubicOut
                );
        }
    }

    p.stop = function () {
        if (!this._isMoving) {
            return;
        }

        this._isMoving = false;

        this._render(0, 0, this._backSpeed, this._backEase);

        this._zoom(1);

        $(win).off('mousemove', this._onMovingHandler);
    }

    p._render = function (x, y, speed, ease) {
        createjs.Tween.get(
            this,
            {
                override: true,
                onChange: this._onAniUpdate.bind(this)
            }
        ).to(
            {
                _aniValueX: x,
                _aniValueY: y
            },
            speed,
            createjs.Ease[ease] || createjs.Ease.cubicOut
            );
    }

    p._onAniUpdate = function (evt) {
        this.$target.css('transform', 'translate3d(' + this._aniValueX + 'px,' + this._aniValueY + 'px, 0) scale(' + this._scaleObj.scale + ')');
    }

    p.execute = function (funcName, funcParams) {
        if (!funcName || this._allowCalls.indexOf(funcName) < 0) {
            return;
        }

        if (!Array.isArray(funcParams)) {
            funcParams = [funcParams];
        }

        var f = this[funcName];
        if (f && typeof (f) === 'function') {
            return f.apply(this, funcParams);
        }
    }

    p.dispose = function () {
        if (this._disposed) {
            return;
        }

        var index = elaticHovers.indexOf(this);
        if (index > -1) {
            elaticHovers.splice(index, 1);
        }

        this._disposed = true;

        createjs.Tween.removeTweens(this);
        $(win).off('mousemove', this._onMovingHandler);
        this.$element.off('mouseenter mouseleave');

        this._onMovingHandler = null;

        this._element.__ptElasticHover = null;
    }

    $.fn.extend({
        ptElasticHover: function (obj) {
            var isDevice = /Mobi|Tablet|iPad|iPhone|Android/i.test(navigator.userAgent);
            if (isDevice || win.PT_REMOVE_ELASTIC_HOVER) {
                return this;
            }

            this.each(function () {
                var eh = this.__ptElasticHover;
                eh && eh.dispose();
                new ElasticHover(this, obj || {});
            });
            return this;
        },
        ptElasticHoverCall: function (funcName, funcParams) {
            var arr = [];
            this.each(function () {
                var eh = this.__ptElasticHover;
                var returnValue = eh && eh.execute(funcName, funcParams);
                arr.push({ target: this, value: returnValue });
            });
            return arr;
        }
    });
})(jQuery, window);


// (function($) {
//     $('.images > div > img').ptElasticHover({
//         scale: 1
//     });
// })(jQuery);